export const [PROPOSAL_FETCHED] = ['PROPOSAL_FETCHED']